import { ScheduleGateway } from "../domain/schedule.gateway";

export class ConfirmUseCase {
    constructor(private gate: ScheduleGateway) {}

    async execute(ids: string[]): Promise<boolean> {
        return this.gate.confirm(ids);
    }
}
